module.exports = __webpack_public_path__ + "media/icons/nav-arrow-right-780a7a5a.svg";